var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeStones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.708 44.5571H74.7083H74.7248C75.4321 44.5571 76.0895 44.2897 76.5948 43.7886C77.0998 43.2878 77.3865 42.6195 77.3865 41.9172V38.6882C77.3865 37.2346 76.2071 36.0484 74.7415 36.0483C74.7415 36.0483 74.7414 36.0483 74.7414 36.0483L57.3693 35.95L57.2919 35.9496L57.3233 36.0203L57.7643 37.012L57.3194 41.9113L56.9505 44.4014L56.9421 44.4584L56.9997 44.4587L74.708 44.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62845 44.5571L6.62817 44.5571L6.61165 44.5571C5.90434 44.5571 5.24701 44.2897 4.74168 43.7886C4.23668 43.2878 3.95001 42.6195 3.95001 41.9172L3.95 38.6882C3.95 37.2346 5.12935 36.0484 6.59496 36.0483C6.59501 36.0483 6.59506 36.0483 6.59511 36.0483L23.0746 35.95L23.1249 35.9497L23.1249 36L23.1249 36.9835L23.1256 36.9835L23.1242 36.9918L22.5513 40.3754L23.5668 43.7313L24.0088 44.3806L24.0616 44.4582L23.9678 44.4587L6.62845 44.5571Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2645 40.1783C25.2645 48.5823 32.1636 55.4066 40.6207 55.4066C49.0944 55.4066 55.9769 48.5822 55.9769 40.1783C55.9769 31.7744 49.0944 24.95 40.6207 24.95C32.147 24.95 25.2645 31.7744 25.2645 40.1783ZM26.1745 40.1947C26.1745 32.2893 32.6477 25.8696 40.6207 25.8696C48.5937 25.8696 55.0669 32.2893 55.0669 40.1947C55.0669 48.1 48.5937 54.5198 40.6207 54.5198C32.6477 54.5198 26.1745 48.1 26.1745 40.1947Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8689 30.0157H30.3725V50.3409H50.8689V30.0157Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6054 25.8075L26.1122 40.1795L40.6054 54.5516L55.0985 40.1795L40.6054 25.8075Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 40.5,
    r: 7,
    fill: "white",
    stroke: "#343333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 40.5,
    r: 7,
    fill: "white",
    stroke: "#343333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStones);
export default __webpack_public_path__ + "static/media/ThreeStones.93ef2781734fee2a3b82e62237d20bee.svg";
export { ForwardRef as ReactComponent };